import { trpc } from '../../config/trpc';

export const useBooking = () => {
  const { mutateAsync: createBooking, isLoading: isBooking } = trpc.bookQuoteVariant.useMutation();
  const { mutateAsync: updateBooking, isLoading: isUpdatingBooking } = trpc.updateBookedQuoteVariant.useMutation();
  const { mutateAsync: refreshBooking, isLoading: isRefreshingBooking } = trpc.refreshBookedQuoteVariant.useMutation();
  const { mutateAsync: cancelBooking, isLoading: isRemovingBooking } = trpc.clearQuoteVariantBooking.useMutation();
  const { mutateAsync: switchBooking, isLoading: isSwitchingBooking } = trpc.switchBookedQuoteVariant.useMutation();

  const isLoading = isBooking || isRemovingBooking || isSwitchingBooking || isUpdatingBooking || isRefreshingBooking;

  return {
    isLoading,

    createBooking,
    updateBooking,
    cancelBooking,
    switchBooking,
    refreshBooking,
  };
};
